import { jsx as _jsx } from "react/jsx-runtime";
import { Paper as PaperMui } from '@mui/material';
import { forwardRef } from 'react';
const variants = ['default', 'mini', 'none'];
const paddingMap = {
    default: 106,
    mini: 102,
    none: 0,
};
const mobilePaddingMap = {
    default: 105,
    mini: 102,
    none: 0,
};
export const Paper = forwardRef(function Paper({ children, width, paddingVariant = 'default', variant }, ref) {
    return (_jsx(PaperMui, { ref: ref, elevation: 0, sx: (theme) => ({
            padding: paddingMap[paddingVariant],
            [theme.breakpoints.down('sm')]: {
                padding: mobilePaddingMap[paddingVariant],
            },
            width: width ?? 'initial',
        }), variant: variant ?? 'outlined', children: children }));
});
